import { AlertCircle, X } from "lucide-react";
import { motion, AnimatePresence } from "motion/react";
import { Button } from "@/app/components/button";

interface CartBlockToastProps {
  message: string | null;
  onDismiss: () => void;
  onGoToCart?: () => void;
}

export function CartBlockToast({ message, onDismiss, onGoToCart }: CartBlockToastProps) {
  return (
    <AnimatePresence>
      {message && (
        <>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={onDismiss}
            className="fixed inset-0 bg-black/20 z-50"
          />
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ type: "spring", damping: 25, stiffness: 300 }}
            className="fixed bottom-0 left-0 right-0 z-50 mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-8 pb-6"
          >
            <div className="bg-card border border-border rounded-2xl shadow-2xl overflow-hidden">
              <div className="p-4 flex items-start gap-3">
                <div className="w-10 h-10 rounded-full bg-amber-500/20 flex items-center justify-center shrink-0">
                  <AlertCircle className="w-5 h-5 text-amber-600 dark:text-amber-400" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-semibold text-foreground mb-1">
                    Não foi possível adicionar
                  </h3>
                  <p className="text-sm text-muted-foreground mb-4">
                    {message}
                  </p>
                  <div className="flex flex-col gap-2">
                    {onGoToCart && (
                      <Button
                        onClick={() => {
                          onDismiss();
                          onGoToCart();
                        }}
                        className="w-full"
                        size="lg"
                      >
                        Ir para o Carrinho
                      </Button>
                    )}
                    <Button
                      onClick={onDismiss}
                      variant="outline"
                      className="w-full"
                      size="lg"
                    >
                      Entendi
                    </Button>
                  </div>
                </div>
                <button
                  onClick={onDismiss}
                  className="p-2 hover:bg-muted rounded-lg transition-colors shrink-0"
                >
                  <X className="w-5 h-5 text-muted-foreground" />
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
